/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_PublishedInputs */

const cs_workflow_published = /** @type {(inputs: Workflow_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow publikován`)
};

const en_workflow_published = /** @type {(inputs: Workflow_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow published`)
};

/**
* | output |
* | --- |
* | "Workflow published" |
*
* @param {Workflow_PublishedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_published = /** @type {((inputs?: Workflow_PublishedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_PublishedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_published(inputs)
	return cs_workflow_published(inputs)
});